import fetchApi from "../../../../lib/fetchApi";
import { ClaimFollowUpTypeSelectItemDto } from "../types";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToclaimFollowUpType = mapDictionaryState;

const claimFollowUpTypeApi = createDictionaryApiFactory("claimFollowUpType");

export const getClaimFollowUpType = claimFollowUpTypeApi.search;

export const getClaimFollowUpTypesSelect = async (): Promise<ClaimFollowUpTypeSelectItemDto[]> => {
    const response = await fetchApi.get(`/claimFollowUpType/select`) as ClaimFollowUpTypeSelectItemDto[];
    return response;
}